import * as React from 'react';
import { SortArrows } from './SortArrows';
import { L } from '../../lib/i18n';
import styled from '@emotion/styled';
import { style } from '../Shared/Style';
interface TableProps {
    data: any;
    columns: any[];
    children?: any;
    padding?: string;
}

interface RowProps {
    data: any;
    children?: any;
    columns: any;
}

const TableContainer = styled.div((props: { gridTemplateColumns: string; padding?: string }) => ({
    background: style.colors.white,
    borderRadius: style.roundCornerSize.small,
    display: 'grid',
    gridTemplateColumns: props.gridTemplateColumns,
    padding: `${props.padding}` || style.margin.l,
    textAlign: 'left',
    border: `solid 1px ${style.colors.black30}`,
    ['@media screen and (max-width: 1024px)']: {
        padding: '10px',
    },
}));

const TableCell = styled.div({
    borderTop: '1px solid lightgrey',
    paddingBottom: style.margin.m,
    paddingTop: style.margin.m,
    ['@media screen and (max-width: 1024px)']: {
        padding: '6px 0px',
        height: 'auto',
        fontSize: '14px',
    },
});

export const Table = (props: TableProps) => {
    const gd = props.columns.map((c) => c.width || '1fr').join(' ');
    const rows = props.data.map((d, index) => <TableRow key={index} data={d} columns={props.columns} />);

    return (
        <TableContainer padding={props.padding || ''} gridTemplateColumns={gd}>
            <TableHeader columns={props.columns} />
            {rows}
        </TableContainer>
    );
};

export const TableRow = (props: RowProps) => {
    const cells = props.columns.map((col) => {
        const data = props.data[col.key];
        return <TableCell key={col.key}>{data}</TableCell>;
    });
    return <>{cells}</>;
};

const TableHeaderColumn = styled('div')({
    color: '#9FA2B4',
    paddingRight: '1rem',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    fontSize: style.fontSize.centi,
    paddingBottom: style.margin.s,
    textTransform: 'uppercase',
    '&:first-of-type': {
        justifyContent: 'left',
    },
    ['@media screen and (max-width: 1024px)']: {
        fontSize: '10px',
    },
});

interface HeaderColumnProps {
    columns: { arrows: boolean; sortby?: () => void; header: string }[];
    children?: any;
}

export const TableHeader = (props: HeaderColumnProps) => {
    const items = props.columns.map((c, index) => (
        <TableHeaderColumn key={index} onClick={c.sortby}>
            {L(c.header)}
            {c.arrows && <SortArrows />}
        </TableHeaderColumn>
    ));
    return <> {items} </>;
};
